'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var website = {
	bindings: {
		value: '@'
	},
	template: '<a href="{{ $ctrl.target }}" target="_blank">{{ $ctrl.value }}</a>',
	controller: function controller() {
		var _this = this;

		this.$onInit = function () {
			if (_this.value.includes('http')) {
				_this.target = _this.value;
			} else {
				_this.target = 'http://'.concat(_this.value);
			}
		};
	}
};

exports.default = website;


/** WEBPACK FOOTER **
 ** ./src/app/directives/common/website.js
 **/